// get userInfo

export function getAdmin() {
  return localStorage.getItem('admin')
}

export function getAvatar() {
  return localStorage.getItem('avatar')
}

export function getUserId() {
  return localStorage.getItem('userId')
}

// 账号名字
export function getUserName() {
  return localStorage.getItem('userName')
}

// 账号的全称
export function getActualName() {
  return localStorage.getItem('actualName')
}

export function getVisitedRoutes() {
  const list = JSON.parse(localStorage.getItem('hhxcNav-list')) || []
  const res = list.filter((item) => item && item.path && item.fullPath)
  return res
}

export function getPermissions() {
  return JSON.parse(localStorage.getItem('permissions')) || []
}

// set userInfo
export const setAdmin = (admin) => {
  return localStorage.setItem('admin', admin)
}

export const setAvatar = (avatar) => {
  return localStorage.setItem('avatar', avatar)
}

export const setUserId = (userId) => {
  return localStorage.setItem('userId', userId)
}

// 账号名字
export const setUserName = (userName) => {
  return localStorage.setItem('userName', userName)
}
// 账号的全称
export const setActualName = (actualName) => {
  return localStorage.setItem('actualName', actualName)
}

export const setVisitedRoutes = (visitedRoutes) => {
  return localStorage.setItem('hhxcNav-list', JSON.stringify(visitedRoutes))
}
